var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.gameConfig
    ? _c("div", [
        _vm._m(0),
        _c("div", { staticClass: "row" }, [
          _c("label", { staticClass: "d-inline mx-10 form-control-label" }, [
            _vm._v(" Start "),
          ]),
          _c(
            "div",
            { staticClass: "d-inline mx-10" },
            [
              _c("DatePicker", {
                ref: "start_date",
                attrs: {
                  type: "datetime",
                  "width-200px": "",
                  confirm: true,
                  clearable: false,
                  placeholder: "n/a",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-type": "format",
                  "disabled-date": _vm.disabledBeforeToday,
                  disabled: _vm.disabled,
                  "show-time-panel": _vm.showTimePanelStart,
                },
                on: {
                  confirm: function ($event) {
                    return _vm.update("start_date")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "mx-btn mx-btn-text",
                              on: {
                                click: function ($event) {
                                  _vm.showTimePanelStart =
                                    !_vm.showTimePanelStart
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.showTimePanelStart
                                      ? "select date"
                                      : "select time"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1062679090
                ),
                model: {
                  value: _vm.gameConfig.start_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.gameConfig, "start_date", $$v)
                  },
                  expression: "gameConfig.start_date",
                },
              }),
            ],
            1
          ),
          _c("label", { staticClass: "d-inline mx-10 form-control-label" }, [
            _vm._v(" End "),
          ]),
          _c(
            "div",
            { staticClass: "d-inline mx-10" },
            [
              _c("DatePicker", {
                ref: "end_date",
                attrs: {
                  type: "datetime",
                  "width-200px": "",
                  confirm: true,
                  placeholder: "n/a",
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-type": "format",
                  disabled: !["draft", "paused"].includes(
                    _vm.gameConfig.status
                  ),
                  "disabled-date": _vm.disabledBeforeStart,
                  "show-time-panel": _vm.showTimePanelEnd,
                },
                on: {
                  confirm: function ($event) {
                    return _vm.update("end_date")
                  },
                  clear: function ($event) {
                    return _vm.update("end_date")
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "mx-btn mx-btn-text",
                              on: {
                                click: function ($event) {
                                  _vm.showTimePanelEnd = !_vm.showTimePanelEnd
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.showTimePanelEnd
                                      ? "select date"
                                      : "select time"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  1160030429
                ),
                model: {
                  value: _vm.gameConfig.end_date,
                  callback: function ($$v) {
                    _vm.$set(_vm.gameConfig, "end_date", $$v)
                  },
                  expression: "gameConfig.end_date",
                },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("label", { staticClass: "form-control-label" }, [
        _c("h4", [_vm._v("Game Instance Duration")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }